import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DictionaryMarkdownPanelAll from './DictionaryMarkdownPanelAll';

const DictionaryMarkdownPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DictionaryMarkdownPanelAll, narrow: DictionaryMarkdownPanelAll }}
  />
);

export default DictionaryMarkdownPanel;
